import { Box, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const SetupBanner = () => {
    const { t } = useTranslation('default');

    return (
        <Box mb="48px">
            <Text
                fontFamily="body"
                fontWeight="medium"
                fontSize="22px"
                color="#1E1517"
            >
                {t('setup.title')}
            </Text>
            <Box borderBottom="1px solid" borderColor="#5C1628" my={3} />
            <Text
                fontFamily="body"
                fontWeight="light"
                fontSize="16px"
                color="#1E1517"
            >
                {t('setup.message')}
            </Text>
        </Box>
    );
};

export default SetupBanner;
